import PersField from "./field";
import PersUpdatedField from "./updated-field";
import PersDatePicker from "./field-datepicker";

export const Field = PersField;

export const UpdatedField = PersUpdatedField;

export const DatePicker = PersDatePicker;
